import isEqual from 'lodash.isequal';
import { useMemo, useRef } from 'react';

export default function useDeepEqualMemo<T>(value: T): T {
  const previousValueRef = useRef<T>(value);

  return useMemo(() => {
    if (!isEqual(previousValueRef.current, value)) {
      previousValueRef.current = value;
    }

    return previousValueRef.current;
  }, [value]);
}
